// extracted by mini-css-extract-plugin
module.exports = {"table-data":"style_table-data__3Yx1R"};